import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const initState = {

  dropngoCategoryList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isLoadingDropngoCategory: false,
  dropngoCategoryListAll: [],
  isDropngoCategoryAddSuccess: false,
  isDropngoCategoryAddFail: false,
  isDropngoCategoryEditSuccess: false,
  isDropngoCategoryEditFail: false,
  isDropngoCategoryRemoveSuccess: false,

  dropngoPriceEffectiveDateList: {},
  dropngoPriceControlList: [],
  isDropngoPriceControlSetSuccess: false,
  isDropngoPriceControlSetFail: false,
  isDropngoPriceRemoveSuccess: false,
  dropngoPricePDF: "",
};

export default function dropngoReducer(state = initState, action) {

  switch (action.type) {

    case actionTypes.LOAD_DROPNGO_CATEGORY: {

      let dropngoCategoryList = cloneDeep(state.dropngoCategoryList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        dropngoCategoryList.offset = action.data.offset;
        dropngoCategoryList.limit = action.data.limit;
      }

      return {
        ...state,
        dropngoCategoryList
      };
    }

    case actionTypes.LOAD_DROPNGO_CATEGORY_SUCCESS: {

      let dropngoCategoryList = cloneDeep(state.dropngoCategoryList);
      dropngoCategoryList.data = action.data.data;
      dropngoCategoryList.meta = {
        page: 1 + state.dropngoCategoryList.offset / state.dropngoCategoryList.limit,
        pageSize: state.dropngoCategoryList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.dropngoCategoryList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        dropngoCategoryList
      };
    }

    case actionTypes.LOAD_DROPNGO_CATEGORY_FAIL: {
      return {
        ...state,
      };
    }


    case actionTypes.LOAD_DROPNGO_CATEGORY_ALL: {

      return {
        ...state,
        isLoadingDropngoCategory: true,
        dropngoCategoryListAll: []
      };
    }

    case actionTypes.LOAD_DROPNGO_CATEGORY_ALL_SUCCESS: {

      return {
        ...state,
        isLoadingDropngoCategory: false,
        dropngoCategoryListAll: action.data
      };
    }

    case actionTypes.LOAD_DROPNGO_CATEGORY_ALL_FAIL: {
      return {
        ...state,
        isLoadingDropngoCategory: false,
      };
    }

    case actionTypes.ADD_DROPNGO_CATEGORY: {
      return {
        ...state,
        isDropngoCategoryAddSuccess: false,
        isDropngoCategoryAddFail: false,
      };
    }

    case actionTypes.ADD_DROPNGO_CATEGORY_SUCCESS: {
      return {
        ...state,
        isDropngoCategoryAddSuccess: true
      };
    }

    case actionTypes.ADD_DROPNGO_CATEGORY_FAIL: {
      return {
        ...state,
        isDropngoCategoryAddFail: true
      };
    }


    case actionTypes.EDIT_DROPNGO_CATEGORY: {
      return {
        ...state,
        isDropngoCategoryEditSuccess: false,
        isDropngoCategoryEditFail: false,
      };
    }

    case actionTypes.EDIT_DROPNGO_CATEGORY_SUCCESS: {
      return {
        ...state,
        isDropngoCategoryEditSuccess: true
      };
    }

    case actionTypes.EDIT_DROPNGO_CATEGORY_FAIL: {
      return {
        ...state,
        isDropngoCategoryEditFail: true
      };
    }


    case actionTypes.DELETE_DROPNGO_CATEGORY: {
      return {
        ...state,
        isDropngoCategoryRemoveSuccess: false
      };
    }

    case actionTypes.DELETE_DROPNGO_CATEGORY_SUCCESS: {
      return {
        ...state,
        isDropngoCategoryRemoveSuccess: true
      };
    }

    case actionTypes.DELETE_DROPNGO_CATEGORY_FAIL: {
      return {
        ...state,
        isDropngoCategoryRemoveSuccess: false
      };
    }


    case actionTypes.LOAD_DROPNGO_PRICE_EFFECTIVE_DATE_LIST: {

      return {
        ...state,
        dropngoPriceEffectiveDateList: {},
      };
    }

    case actionTypes.LOAD_DROPNGO_PRICE_EFFECTIVE_DATE_LIST_SUCCESS: {

      return {
        ...state,
        dropngoPriceEffectiveDateList: action.data,
      };
    }

    case actionTypes.LOAD_DROPNGO_PRICE_EFFECTIVE_DATE_LIST_FAIL: {
      return {
        ...state,
        dropngoPriceEffectiveDateList: {},
      };
    }

    case actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_LOAD: {
      return {
        ...state,
        dropngoPriceControlList:[],
      };
    }

    case actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_LOAD_SUCCESS: {
      return {
        ...state,
        dropngoPriceControlList: action.data,
      };
    }

    case actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_LOAD_FAIL: {
      return {
        ...state
      };
    }


    case actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_SET: {
      return {
        ...state,
        isDropngoPriceControlSetSuccess: false,
        isDropngoPriceControlSetFail: false
      };
    }

    case actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_SET_SUCCESS: {
      return {
        ...state,
        isDropngoPriceControlSetSuccess: true
      };
    }

    case actionTypes.DROPNGO_CATEGORY_PRICE_CONTROL_SET_FAIL: {
      return {
        ...state,
        isDropngoPriceControlSetFail: true
      };
    }


    case actionTypes.DELETE_DROPNGO_CATEGORY_PRICE: {
      return {
        ...state,
        isDropngoPriceRemoveSuccess: false,
      };
    }

    case actionTypes.DELETE_DROPNGO_CATEGORY_PRICE_SUCCESS: {

      return {
        ...state,
        isDropngoPriceRemoveSuccess: true,
      };
    }

    case actionTypes.DELETE_DROPNGO_CATEGORY_PRICE_FAIL: {
      return {
        ...state,
        isDropngoPriceRemoveSuccess: false
      };
    }


    case actionTypes.GET_DROPNGO_CATEGORY_PRICE_PDF: {

      return {
        ...state,
        dropngoPricePDF: ""
      };
    }

    case actionTypes.GET_DROPNGO_CATEGORY_PRICE_PDF_SUCCESS: {

      return {
        ...state,
        dropngoPricePDF: action.data
      };
    }

    case actionTypes.GET_DROPNGO_CATEGORY_PRICE_PDF_FAIL: {
      return {
        ...state
      };
    }

    default:
      return state;
  }
}
